/* eslint-disable import/no-cycle */
import React, { useState, useContext } from 'react';

import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { GlobalContext } from '../../layout';

import HelpSubMenu from './helpSubMenu';

const CommonMenu = ({ locale, setSidebarVisible }) => {
  const { defectNotificationCount } = useContext(GlobalContext);
  const history = useHistory();

  const [showHelpSubMenu, setShowHelpSubMenu] = useState(false);

  const navigateTo = link => {
    setSidebarVisible(false);
    history.push(link);
  };

  return (
    <ul className="mobile-navbar-list">
      <li className="mobile-navbar-list-item">
        <button
          type="button"
          onClick={() => navigateTo('/')}
          className="mobile-navbar-list-item-inner"
        >
          <p className="mobile-navbar-menu-item">Home</p>
        </button>
      </li>
      <li className="mobile-navbar-list-item">
        <button
          type="button"
          onClick={() => setShowHelpSubMenu(!showHelpSubMenu)}
          className="mobile-navbar-list-item-inner"
        >
          <p className="mobile-navbar-menu-item">Help</p>
          {showHelpSubMenu ? <span>&darr;</span> : <span>&rarr;</span>}
        </button>
        {showHelpSubMenu && <HelpSubMenu locale={locale} />}
      </li>
      <li className="mobile-navbar-list-item">
        <button
          type="button"
          onClick={() => navigateTo('/report-an-issue')}
          className="mobile-navbar-list-item-inner"
        >
          <p className="mobile-navbar-menu-item">Report an Issue</p>
          {defectNotificationCount > 0 && (
            <span
              className="badge badge-pill badge-danger"
              style={{ padding: '0.4rem' }}
            >
              {defectNotificationCount}
            </span>
          )}
        </button>
      </li>
    </ul>
  );
};

CommonMenu.propTypes = {
  locale: PropTypes.string.isRequired,
  setSidebarVisible: PropTypes.func.isRequired
};

export default CommonMenu;
